import { CompanyUser, Contact, UserDescription, UserMedical } from '@/api';

/**
 * A company user the requesting user sees in full.
 *
 * The API withholds the medical, contacts and description fields when its
 * `access` is `'limited'` — a plain member of a team they share. This is the
 * same user with those three fields known to be present, so the sections that
 * read them don't each have to cope with their absence.
 */
export type FullAccessCompanyUser = CompanyUser & {
    medical: UserMedical;
    contacts: Contact[];
    description: UserDescription;
};

/** Narrows a company user to one whose withheld fields are all present. */
export function hasFullAccess(
    user: CompanyUser
): user is FullAccessCompanyUser {
    return user.access === 'full';
}
